@if (pallet(); as pallet) {
  <div class="flex flex-row items-center gap-2">
    @if (!hideIcon()) {
      <soft-icon name="fa-regular fa-pallet-boxes"></soft-icon>
    }
    <div class="flex flex-col w-full">
      <span class="text-lg font-semibold">{{ pallet?.sscc }}</span>
      <span class="text-sm text-light"
        >{{ pallet?.menge }} {{ pallet?.einheit?.arteh }}</span
      >
    </div>
    @if (stockyard() || items()) {
      <div class="flex items-center gap-2">
        <div
          class="flex flex-row justify-center items-center bg-info text-info-contrast rounded-full cursor-pointer size-8! hover:bg-info-800 hover:text-info-contrast-800"
          (click)="openInfoModal(); $event.stopPropagation(); $event.preventDefault()"
        >
          <soft-icon name="fa-regular fa-info"></soft-icon>
        </div>

        <ng-content></ng-content>
      </div>
    }
  </div>
}
